<template>
    <div class="employ-detail">
        <div class="employ-h3">物业管理员</div>
        工作职责：1.负责设备的调试及维修工作 2.协助工程师做安装工作 3.对公司售出产品进行售后服务和维修 及时到达客户地点并快速解决故障 如不能现场完成的                                   应当与客  户协商好后续的维修工作 4.认真填写《售后服务单》3-5年 | 大专以上 | 5000-8000元工作职责：1.负责设备的调试及维修工作 2.协助工程师做安装工作 3.对公司售出产品进行售后服务和维修 及时到达客户地点并快速解决故障 如不能现场完成的应当与客  户协商好后续的维修工作 4.认真填写《售后服务单》3-5年 | 大专以上 | 5000-8000元
    </div>    
</template>

<script>
export default {
        name: 'Recruit',
        data () {
            return {
                name:'',
                content:''
            }
        },
        mounted(){
            this.baseUrl = window.baseUrl;
            this.config = window.config;
            this.recruitment();
        },
        methods:{
            show:function(j){
                this.index = j;
                console.log(this.index)
            },
            recruitment: function(){
                var that = this;
                //招聘岗位
                that.$http.post(that.baseUrl+that.config.recruitment).then(function(ev){
                    console.log(ev);
                    if(ev.data.code == 100){
                        that.tableData = ev.data.data;
                    }
                }).catch(function(error){
                    console.log(error)
                })
            },
            toDetail: function(id){
                this.$router.push({
                    name: 'RecruitDetail',
                    params: {
                        id: id
                    }
                })
            }
        },
        created(){

        },
    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/RecruitDetail.vue